import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import ReportIssueModal from '../components/ReportIssueModal';
import { useNotificationStore } from '../store/notificationStore';
import { useHelpStore } from './helpStore';
import HelpModal from './HelpModal';
import './help.css';

/**
 * Mounted once by App: the Help modal whenever `openHelp()` was called, and
 * the existing Report-an-issue form as its sibling (so the form survives Help
 * closing underneath it).
 */
export default function HelpHost() {
  const open = useHelpStore((s) => s.open);
  const closeHelp = useHelpStore((s) => s.closeHelp);
  const [reportOpen, setReportOpen] = useState(false);

  // ReportIssueModal still speaks the old showToast(message, type) shape;
  // showToast itself is dead app-wide, so route it to the notification store.
  const notify = useCallback((message, type = 'info') => {
    const store = useNotificationStore.getState();
    (store[type] || store.info)(message);
  }, []);

  return (
    <>
      {open &&
        createPortal(
          <HelpModal onClose={closeHelp} onReport={() => setReportOpen(true)} reportOpen={reportOpen} />,
          document.body
        )}
      {/* Mounted on open so its portal lands AFTER Help's in <body> and
          stacks above it at the same z-index. */}
      {reportOpen && <ReportIssueModal isOpen onClose={() => setReportOpen(false)} showToast={notify} />}
    </>
  );
}
